<template>
    <div class="bax-section bax-select-patient-wrap">
        <div class="container bax-wide">
            <div class="bax-bg bax-bg-foot-link bax-create-patient">
    <div>

        <div v-if="process" class="bax-nested-element">

            <div class="bax-inline-element d-md-flex">
                <div class="bax-form-group">
                    <p>Please review the data to be imported below. Each row that is ticked will become an imported order line.</p>
                </div>
            </div>
            <template v-if="fields_substituted">
                <div class="bax-inline-element d-md-flex" v-if="needs_order_reference">
                    <div class="bax-form-group" style="width: 50%">
                        <p>There is no Order Reference in this file, please provide an order reference for this order</p>
                    </div>
                    <div class="bax-form-group ">
                        <p><input placeholder="order_reference" type="text" maxlength="20" v-model="entered_order_reference"/></p>
                    </div>
                </div>

                <div class="bax-inline-element d-md-flex" v-if="!fields_substituted.includes('delivery_date') || this.missing_delivery_dates">
                    <div class="bax-form-group" style="width: 50%">
                        <p>There are missing Delivery Dates in this file, please provide a delivery date for orders that do not have one</p>
                    </div>
                    <div class="bax-form-group ">
                        <p><date-entry v-model="entered_delivery_date" ref="dateEntryComp1"></date-entry></p>
                    </div>
                </div>
            </template>

            <div v-if="process" class="bax-inline-element d-md-flex">
                <div class="bax-form-group" style="width: 50%">
                    <p>Would you like these orders to be created as Drafts, or submitted immediately?</p>
                </div>
                <div class="bax-form-group ">
                    <p><select name="create_option" v-model="entered_create_option">
                        <option value="draft">Created as Drafts</option>
                        <option value="submit">Submitted Immediately</option>
                    </select></p>
                </div>
            </div>
        </div>

        <div class="csv-upload-review"  v-if="fields_substituted && fields_substituted[0]">
            <input type="button" class="bax-btn bax-btn-mini bax-btn-blue ml-auto mt-3 mt-md-0" :value="showing_original_data?'Hide Original Data':'Show Original Data'" @click.prevent="showing_original_data = !showing_original_data" />
            <table v-if="rows">
                <thead>
                <tr>
                    <th>Select <a @click.prevent="select_helper('all');" class="select-helper">All</a> | <a @click.prevent="select_helper('none');" class="select-helper">None</a></th>
                    <th class="fieldname-header">Baxter Field Name <span class="rarr">&rarr;</span></th>
                    <template v-for="(field_name) in fields_substituted">
                        <th v-bind:key="field_name" v-if="!(fields_to_hide.includes(field_name))">
                            {{ field_name }}
                        </th>
                    </template>
                </tr>
                </thead>
                <tbody>
                <template v-for="(row, row_key, row_index) in rows_substituted">
                    <tr v-bind:key="rows_error[row_key] + row_index + ' ' + row_key + rowupdater">
                        <td><input type="checkbox" checked="checked"  :id="row_key" v-model="selectedRows" :value="row_key" :disabled="(rows[row_key].status === 'Submitted') || ((rows_error[row_key]) && (!rows_error[row_key].includes('Warning :'))) || ((rows_error[row_key]) && (rows_error[row_key].includes('Error :'))) || (rows_substituted[row_key].row_master !== false)"/></td>
                        <td>{{rows[row_key].status}} <span v-if="rows_error[row_key]" :class="row_class(rows_error[row_key])" v-html="rows_error[row_key]"><img class="loading_animation" src="@/assets/images/loading.gif" alt="Loading" /> {{}}</span> </td>
                        <template v-for="(field) in fields_substituted">
                            <template v-if="!(fields_to_hide.includes(field))">
                                <td v-bind:key="field">{{ row[field] }}</td>
                            </template>
                        </template>
                    </tr>
                </template>
                <tr v-if="fields_substituted && showing_original_data">
                    <th></th>
                    <th class="fieldname-header selector-header">Your field name <span class="rarr">&rarr;</span></th>
                    <template v-for="(field_name, i) in this.fields">
                        <th v-bind:key="field_name" v-if="!(fields_to_hide.includes(fields_substituted[i]))">
                            {{field_name}}
                        </th>
                    </template>                </tr>
                <template v-for="(row, row_key, row_index) in rows_substituted">
                    <tr v-bind:key="'row_' + row_index" class="original-data" v-if="showing_original_data">
                        <td></td>
                        <td>Original Data</td>
                        <template v-for="(field, field_name, field_index) in rows[row_key]">
                            <td v-bind:key="field_index + 'row_' + row_index + rows[row_key].status" v-if="fields_substituted[field_index] && !(fields_to_hide.includes(fields_substituted[field_index]))">
                                {{ field }}
                            </td>
                        </template>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>

        <div class="action-buttons">
            <p v-if="!completed">
            </p>
            <p v-if="completed">
                Your import is complete.
                <input type="button" value="Return home" class="bax-btn bax-btn-blue ml-auto mt-3 mt-md-0" @click="goHome">
            </p>
            <p>
                <input v-if="!completed" type="button" value="Finalize Upload" class="bax-btn bax-btn-blue ml-auto mt-3 mt-md-0" @click="startProcess" :disabled="disableSubmit()">
                <input type="button" value="Cancel Upload" class="cancel-btn bax-btn bax-btn-bordered bax-btn-bordered-blue ml-auto mt-3 mt-md-0"  @click="cancelUpload" >
                <input v-if="process" type="button" :value="'Submit ' + selectedRows.length + ' Order Line' + (selectedRows.length === 1?'':'s')" class="bax-btn bax-btn-blue ml-auto mt-3 mt-md-0"  @click="processSubmitOrder" :disabled="disableSubmit()">
            </p>
        </div>
    </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CsvService from '@/core/api/csv/csv.service3';
    import OrderDrugService from '@/core/api/order/orderDrug.service';
    import PatientService from '@/core/api/patient/patient.service';
    import moment from 'moment';
    import OrderService from '@/core/api/order/order.service';
    import DateEntry from '@/components/ui/DateEntry.vue';

    import csvMixin from './csvMixin';

    export default {
        name: 'Stage5',
        mixins: [csvMixin],
        components: { DateEntry },
        props: ['uploadCode'],
        data() {
            return {
                rows: {},
                rows_substituted: null,
                fields: false,
                fields_substituted: false,
                selectedRows: [],
                rows_presentations: [],
                rows_error: {},
                completed: false,
                process: false,
                errors: [],
                error_status: null,
                filename: null,
                headers_file: null,
                rows_num: null,
                rows_valid: null,
                rows_invalid: null,
                cust_headers: [],
                cust_header_chosen: null,
                baxter_headers: [],
                chosen_headers: [],
                headers_changed: false,
                headers_changed_ignore: false,
                headers_name: '',
                prevent_submit_reason: [],
                showing_original_data: false,
                numFields: false,
                order_details: false,
                missing_delivery_dates: false,
                entered_order_reference: null,
                needs_order_reference: false,
                entered_delivery_date: false,
                entered_create_option: 'draft',
                order_submitted: false,
                nextAjaxOoeration: false,
                fields_to_hide: ['row_master'],
                checking_steps: ['Patient Name', 'Max Dosage & Stability'],
                checking_step: 0,
                rowupdater: 0,
            };
        },
        watch: {
            // whenever question changes, this function will run
            selectedRows(newRows) {
                (Object.keys(this.rows)).forEach((row) => {
                    if ((this.rows[row].status !== 'Submitted')) {
                        if (newRows.find((r) => r === row)) {
                            this.$set(this.rows[row], 'status', 'Ready to Submit');
                        } else {
                            // this.row_status[i] = '';
                            this.$set(this.rows[row], 'status', '');
                        }
                    }
                });
                this.populateOrderDetails();
            },
            entered_order_reference() {
                this.populateOrderDetails();
            },
            entered_delivery_date() {
                this.populateOrderDetails();
            },
        },
        created() {
            this.fetchMarkedRows();
        },
        methods: {
            goHome() {
                this.$router.push({ name: 'home' });
            },
            select_helper(what) {
                switch (what) {
                    case 'all':
                        this.selectedRows.splice(0, this.selectedRows.length); // empty the array
                        (Object.keys(this.rows)).forEach((row) => {
                            if (!this.rows_error[row] && (!this.rows_substituted[row].row_master)) {
                                this.selectedRows.push(row);
                            }
                        });
                        this.$forceUpdate();
                    break;
                    case 'none':
                        this.selectedRows.splice(0, this.selectedRows.length); // empty the array
                        break;
                    default:
                        this.selectedRows.splice(0, this.selectedRows.length); // empty the array
                    break;
                }
            },
            fetchMarkedRows() {
                CsvService.fetchCsvRowsForReview(this.uploadCode)
                    .then((res) => {
                        this.completed = false;
                        this.checking_step = 0;
                        this.rows = res.data.rows;
                        this.rows_substituted = res.data.rows_substituted;
                        this.rows_presentations = res.data.rows_presentations;
                        this.fields = res.data.fields;
                        this.fields_substituted = res.data.fields_substituted;
                        this.errors = res.data.errors;
                        this.order_details = false;
                        this.order_submitted = false;
                        this.missing_delivery_dates = false;
                        this.needs_order_reference = true;
                        this.error_status = res.data.errors.status;
                        this.rows_error = [];

                        (Object.keys(this.rows)).forEach((key) => {
                            let errorMessage = '';
                            let row = 0;
                            row = parseInt(key, 10);

                            if (this.errors[row].error != null) {
                                (Object.values(this.errors[row])).forEach((error) => {
                                        (Object.values(error)).forEach((value) => {
                                        errorMessage += value + '<br /> ';
                                    });
                                this.rows_error[key] = errorMessage;
                                });
                            }
                            row = key;

                            if (this.rows_presentations[row].presentation_id) {
                                this.$set(this.rows[row], 'status', '');
                            } else if (!this.rows_substituted[row].row_master) {
                                this.rows_error[row] = 'Error: Presentation not found';
                            }

                            if ((!this.rows_substituted[row].row_master) && (!this.rows_substituted[row].patient_id || (this.rows_substituted[row].patient_id.length === 0)) && ((this.rows_substituted[row].firstname || (this.rows_substituted[row].firstname.length !== 0)) || (this.rows_substituted[row].surname || (this.rows_substituted[row].surname.length !== 0)))) {
                                this.rows_error[row] = "Error: Missing patient details";
                            }

                            if ((!this.rows_substituted[row].row_master) && (!this.rows_substituted[row].container || (this.rows_substituted[row].container.length === 0))) {
                                this.rows_error[row] = "Error: Missing container";
                            }
                            if ((!this.rows_substituted[row].row_master) && (typeof this.rows_presentations[row].container_description_option === 'undefined')) {
                                if (this.rows_error[row]) {
                                    this.rows_error[row] = 'Error: Container unavailable';
                                }
                            }

                            if (!this.rows_substituted[row].delivery_date || (this.rows_substituted[row].delivery_date.length === 0)) {
                                this.missing_delivery_dates = true;
                            }

                            if (this.rows_substituted[row].order_reference) {
                                if (this.rows_substituted[row].order_reference.length > 0) {
                                    this.needs_order_reference = false;
                                }
                            }
                        });
                        this.$emit('waiting_set', 'Populating order details');
                        this.populateOrderDetails();
                        if (this.error_status === 'processed') {
                            this.process = true;
                        }
                    });
            },
            row_class(errorText) {
                if (errorText.includes('Checking')) {
                    return 'status';
                }
                if (errorText.includes('Error')) {
                    return 'error';
                }
                if (errorText.includes('Warning')) {
                    return 'warning';
                }
                return 'error';
            },
            fetchHeaders() {
                CsvService.getReviewHeaders(5).then(async (resHeaders) => {
                    this.cust_headers = resHeaders.data.user_headers;
                    this.baxter_headers = resHeaders.data.baxter_headers;
                    this.substituted_headers = resHeaders.data.substituted_headers;
                });
            },
            populateOrderDetails() {
                this.order_details = {};
                this.order_submitted = false;
                (Object.keys(this.rows_substituted)).forEach((row) => {
                    if (this.selectedRows.includes(row)) {
                        const rowData = (this.rows_substituted[row]);
                        const presentation = (this.rows_presentations[row]);

                        let orderDate = '';
                        if (rowData.delivery_time) {
                            orderDate = moment(this.entered_delivery_date ? this.entered_delivery_date : rowData.delivery_date + ' ' + rowData.delivery_time, 'DD/MM/YYYY hh:mm a');
                        } else {
                            orderDate = moment(this.entered_delivery_date ? this.entered_delivery_date : rowData.delivery_date, 'DD/MM/YYYY');
                        }

                        // const timeStamp = orderDate.format('ssmmHHDDMMYY');
                        let orderReference = this.entered_order_reference ? this.entered_order_reference : rowData.order_reference;

                        if (!orderReference) {
                            orderReference = 'temporderref';
                        }

                        if (!(orderReference in this.order_details)) {
                            this.order_details[orderReference] = {};
                            this.order_details[orderReference].status = 'new';

                            this.order_details[orderReference].start = {};

                            this.order_details[orderReference].orderId = false;

                            this.order_details[orderReference].start.orderRef = orderReference;
                            this.order_details[orderReference].start.deliveryDate = this.entered_delivery_date ? this.entered_delivery_date : orderDate.format('DD/MM/YYYY') ?? '';
                            this.order_details[orderReference].start.deliveryTime = orderDate.format('HH:mm') ? orderDate.format('HH:mm') : '';
                            this.order_details[orderReference].start.comment = '';
                            this.order_details[orderReference].start.type = 'csv';

                            this.order_details[orderReference].patients = {};
                            this.order_details[orderReference].drugs = [];
                            this.order_details[orderReference].row = row;
                        }

                        if (!(rowData.patient_id in this.order_details[orderReference].patients)) {
                            if (rowData.patient_id) {
                                this.order_details[orderReference].patients[rowData.patient_id] = {};
                                this.order_details[orderReference].patients[rowData.patient_id].id = rowData.patient_id;
                                this.order_details[orderReference].patients[rowData.patient_id].firstName = rowData.firstname;
                                this.order_details[orderReference].patients[rowData.patient_id].lastName = rowData.surname;
                                this.order_details[orderReference].patients[rowData.patient_id].dateOfBirth = rowData.dob;
                                this.order_details[orderReference].patients[rowData.patient_id].wardId = null;
                                this.order_details[orderReference].patients[rowData.patient_id].addedPatientToOrder = false;
                                this.order_details[orderReference].patients[rowData.patient_id].foundPatient = false;
                                this.order_details[orderReference].patients[rowData.patient_id].row = row;
                            }
                        }

                        const drugData = {
                            addedDrugToOrder: false,
                            row_id: row,
                            orderRef: false,
                            patientId: rowData.patient_id ? rowData.patient_id : 0,
                            quantity: rowData.quantity,
                            drugPresentationId: presentation.presentation_id,
                            drug1_name: rowData.drug_name,
                            drug1Dose: rowData.drug_dose,
                            drug1_maxdose_uom: rowData.drug_dose_unit ? rowData.drug_dose_unit : 'mg',
                            diluentVolume: rowData.exact_volume,
                            diluentExactFinalVolume: false,
                            onHold: false,
                            ancillary1Id: presentation.ancillary_1_id ?? false,
                            ancillary2Id: presentation.ancillary_2_id ?? false,
                            infusionTime: parseFloat(rowData.infusion_time),
                            infusionTimeDuration: rowData.infusion_time_unit,
                            overrideStability: (this.rows_error[row]).includes('Stability not found'),
                            overrideDosage: (this.rows_error[row]).includes('Drug dose exceeds max dose'),
                            type: 'PS',
                        };
                        if (rowData.patient_id) {
                            drugData.treatmentDate = rowData.treatment_date;
                        }
                        if (presentation.container_options) {
                            [drugData.containerTypeId] = Object.keys(presentation.container_options);
                            [drugData.container_type_id] = Object.keys(presentation.container_options);
                        }
                        if (presentation.admin_route_options) {
                            [drugData.adminRouteCode] = Object.keys(presentation.admin_route_options);
                        }
                        if (presentation.container_description_option) {
                            drugData.containerPartCode = presentation.container_description_option.containerPartCode;
                            drugData.containerId = presentation.container_description_option.containerID;
                            drugData.container_id = drugData.containerId;
                            drugData.size = presentation.container_description_option.sizeInDefaultUOM;
                            drugData.diluentVolume = parseInt(presentation.container_description_option.sizeInDefaultUOM, 10);
                        }

                        if (presentation.diluent_options) {
                            [drugData.diluent_id] = Object.keys(presentation.diluent_options);
                        }

                        if (!drugData.diluent_id) {
                            drugData.diluent_id = '';
                        }

                        if (presentation.drug1) {
                            if (presentation.drug1.drug1_uoms_options) {
                                [drugData.drug1_maxdose_uom] = Object.keys(presentation.drug1.drug1_uoms_options);
                            }
                        }
                        if (rowData.drug2_name) {
                            drugData.drug2_name = rowData.drug2_name;
                            drugData.drug2_dose = rowData.drug2_dose;
                            drugData.drug2Dose = rowData.drug2_dose;
                            drugData.drug2_maxdose_uom = rowData.drug2_dose_unit ? rowData.drug2_dose_unit : '';
                        }

                        if (rowData.exact_volume) {
                            drugData.exact_volume = rowData.exact_volume;
                            drugData.diluentVolume = rowData.exact_volume;
                            drugData.diluentExactFinalVolume = true;
                        }


                        if (rowData.comments) {
                            drugData.commentLog = rowData.comments;
                        }

                        const dateRow = [this.entered_delivery_date ? this.entered_delivery_date : rowData.delivery_date, (rowData.patient_id ? rowData.treatment_date : false), rowData.quantity];

                        drugData.deliveryDateArray = [dateRow];

                        this.order_details[orderReference].drugs.push(drugData);
                    }
                });
                this.$emit('waiting_set', false);
            },
            setRowStatus(row, status) {
                if (row) {
                    this.$set(this.rows[row], 'status', status);
                }
            },
            processNextBit() {
                setTimeout(() => {
                    // 1 second delay
                    this.processSubmitOrder();
                }, 200);
            },
            async processSubmitOrder() {
                this.order_submitted = true;
                let orderRef = false;
                let order = false;
                (Object.keys(this.order_details)).forEach((foundOrderRef) => {
                    if (!order) {
                        this.completed = true;
                        if (this.order_details[foundOrderRef].status !== 'submitted') {
                            this.completed = false;
                            order = this.order_details[foundOrderRef];
                            orderRef = foundOrderRef;
                        }
                    }
                });
                if (order) {
                    if (order.status === 'new') {
                        const basicorderinfo = order.start;
                        this.order_details[orderRef].status = 'ajaxing';
                        OrderService.createOrder(basicorderinfo)
                            .then((orderres) => {
                                this.order_details[orderRef].status = 'findingpatients';
                                this.order_details[orderRef].orderId = (orderres.data.orderRef);
                                this.processNextBit();
                            });
                    } else if (order.status === 'findingpatients') {
                        let patient = false;
                        (Object.keys(order.patients)).forEach((foundPatientId) => {
                            if (!patient) {
                                if (!order.patients[foundPatientId].foundPatient) {
                                    patient = order.patients[foundPatientId];
                                }
                            }
                        });

                        if (patient) {
                            try {
                                await PatientService.searchPatient({
                                    firstName: '',
                                    lastName: '',
                                    patientId: patient.id,
                                }).then((foundPatientData) => {
                                    const foundPatientList = foundPatientData.data;
                                    let foundPatient = false;
                                    foundPatientList.forEach((checkPatient) => {
                                        if (checkPatient.medicalRecordNumber === patient.id) {
                                            foundPatient = checkPatient;
                                        } else if (this.ltrim0(checkPatient.medicalRecordNumber) === this.ltrim0(patient.id)) {
                                            // found patient with zeros trimmed
                                            foundPatient = checkPatient;
                                        }
                                    });
                                    if (!foundPatient) {
                                        throw new Error('MRN does not match');
                                    }
                                    this.order_details[orderRef].patients[patient.id].foundPatient = true;
                                    this.processNextBit();
                                });
                            } catch (err) {
                                // patient does not exist
                                this.setRowStatus(patient.row, 'Creating Patient');
                                PatientService.createPatient(patient).then(() => {
                                    this.order_details[orderRef].patients[patient.id].foundPatient = true;
                                    this.processNextBit();
                                })
                                    .catch((createaerr) => {
                                        if (createaerr.response.status === 409) {
                                            this.patientExistError = err.response.data.message;
                                            this.patientExistModal = true;
                                        }
                                    });
                            }
                        } else {
                            // been through all patients, we must be finished now
                            this.order_details[orderRef].status = 'addingpatients';
                            this.processNextBit();
                        }
                    } else if (order.status === 'addingpatients') {
                        let patient = false;
                        (Object.keys(order.patients)).forEach((foundPatientId) => {
                            if (!patient) {
                                if (!order.patients[foundPatientId].addedPatientToOrder) {
                                    patient = order.patients[foundPatientId];
                                }
                            }
                        });

                        if (patient) {
                            const addOrderData = {
                                orderRef: order.orderId,
                                patientId: patient.id,
                            };
                            OrderService.addOrderPatient(addOrderData)
                                .then(() => {
                                    this.order_details[orderRef].patients[patient.id].addedPatientToOrder = order.orderId;
                                    this.processNextBit();
                                });
                        } else {
                            // been through all patients, we must be finished now
                            this.order_details[orderRef].status = 'addingdrugs';
                            this.processNextBit();
                        }
                    } else if (order.status === 'addingdrugs') {
                        let drug = false;
                        let drugFoundIndex = false;
                        (Object.keys(order.drugs)).forEach((foundDrugId) => {
                            if (!drug) {
                                if (!order.drugs[foundDrugId].addedDrugToOrder) {
                                    this.order_details[orderRef].drugs[foundDrugId].orderRef = order.orderId;
                                    drug = order.drugs[foundDrugId];
                                    drugFoundIndex = foundDrugId;
                                }
                            }
                        });

                        if (drug) {
                            OrderDrugService.addDrugForPatient(drug)
                                .then(() => {
                                    this.order_details[orderRef].drugs[drugFoundIndex].addedDrugToOrder = true;
                                    this.processNextBit();
                                });
                        } else {
                            // been through all drugs, we must be finished now
                            this.order_details[orderRef].status = 'submitting';
                            this.processNextBit();
                        }
                    } else if (order.status === 'submitting') {
                        if (this.entered_create_option !== 'submit') {
                            OrderService.submitDraftOrder({
                                orderRef: order.orderId,
                                uploadCode: this.uploadCode,
                            })
                                .then((orderres) => {
                                    this.message = orderres.data.message;
                                    this.order_details[orderRef].drugs.forEach((drugrow) => {
                                        this.setRowStatus(drugrow.row_id, 'Draft Created');
                                        this.order_details[orderRef].status = 'submitted';
                                        this.processNextBit();
                                    });
                                })
                                .catch((err) => {
                                    this.draftCreated = false;
                                    this.draftError = true;
                                    this.message = err.response.data.message;
                                });
                        } else {
                            OrderService.submitOrder({
                                orderRef: order.orderId,
                                uploadCode: this.uploadCode,
                            })
                                .then(() => {
                                    // eslint-disable-next-line no-console
                                    this.order_details[orderRef].drugs.forEach((drugrow) => {
                                        this.setRowStatus(drugrow.row_id, 'Complete');
                                        this.order_details[orderRef].status = 'submitted';
                                        this.processNextBit();
                                    });
                                })
                                .catch((err) => {
                                    if (err.response.status === 400) {
                                        this.errorMessage = err.response.data.message;
                                    }
                                })
                                .then(() => {
                                    this.processing = false;
                                });
                        }
                    }
                }
            },
            disableSubmit() {
                // prevent submit if

                let preventSubmit = true;

                preventSubmit = preventSubmit && (this.selectedRows.length === 0); // no rows have been selected

                if (this.order_submitted === true) {
                    preventSubmit = true;
                }
               if (!preventSubmit) {
                    this.prevent_submit_reason = [];
                }
                return preventSubmit;
            },
            startProcess() {
                CsvService.processCsvRowsForReview(this.uploadCode)
                                                .then(() => {
                    this.$router.push({ name: 'home' });
            });
            },
            cancelUpload() {
                CsvService.cancelCsvUpload(this.uploadCode)
                              .then(() => {
                    this.$emit('cancel_upload');
                });
            },
        },
    };
</script>
